import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";
import { deleteEnvironmentVariableRequest } from "Api/variables/environment/deleteEnvironmentVariable.request";
import type { Variable } from "Api/variables/environment/types";

type DeleteEnvironmentVariableThunkProptype = {
  variable: Variable;
  environmentId: string;
  projectId: string;
  organizationId: string;
};

export const deleteVariable = createAsyncThunk<
  Variable,
  DeleteEnvironmentVariableThunkProptype,
  AsyncThunkOptionType<{ error: string }>
>(
  "app/project/environment/variable/delete",
  async (
    { variable, environmentId, projectId, organizationId },
    { rejectWithValue }
  ) => {
    try {
      await deleteEnvironmentVariableRequest(variable);
      return variable;
    } catch (err: any) {
      logger(err, {
        variable,
        environmentId,
        projectId,
        organizationId,
        action: "environmentDeleteVariable"
      });
      return rejectWithValue({ error: err.message });
    }
  },
  {
    condition: ({ variable }) => {
      return !!variable?._links?.["#delete"]?.href;
    }
  }
);
